"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Header = require("./Header/Header");

var _CaretDown = _interopRequireDefault(require("../Icons/CaretDown"));

var _Line = _interopRequireDefault(require("./Line/Line"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RowContainer = _styledComponents["default"].div.withConfig({
  displayName: "MultiDataGridRow__RowContainer",
  componentId: "sc-1bdyxbx-0"
})(["width:100%;display:flex;flex-direction:row;"]);

var MasterLine = (0, _styledComponents["default"])(_Line["default"]).withConfig({
  displayName: "MultiDataGridRow__MasterLine",
  componentId: "sc-1bdyxbx-1"
})(["background-color:#212a3c;position:relative;"]);

var DetailedLines = _styledComponents["default"].div.withConfig({
  displayName: "MultiDataGridRow__DetailedLines",
  componentId: "sc-1bdyxbx-2"
})(["width:100%;display:", ";flex-direction:column;"], function (_ref) {
  var collapsed = _ref.collapsed;
  return collapsed ? 'none' : 'flex';
});

var RowContent = _styledComponents["default"].div.withConfig({
  displayName: "MultiDataGridRow__RowContent",
  componentId: "sc-1bdyxbx-3"
})(["width:100%;display:flex;flex-direction:column;background-color:#171e2c;"]);

var RowScrollableContainer = _styledComponents["default"].div.withConfig({
  displayName: "MultiDataGridRow__RowScrollableContainer",
  componentId: "sc-1bdyxbx-4"
})(["width:100%;overflow:hidden;"]);

var RowScrollableContent = _styledComponents["default"].div.withConfig({
  displayName: "MultiDataGridRow__RowScrollableContent",
  componentId: "sc-1bdyxbx-5"
})(["min-width:4000px;display:flex;flex-direction:column;background-color:#171e2c;"]);

var Collapser = (0, _styledComponents["default"])(_CaretDown["default"]).withConfig({
  displayName: "MultiDataGridRow__Collapser",
  componentId: "sc-1bdyxbx-6"
})(["width:", ";height:", ";color:#79a3ff;margin:10px 2px;transition:all 200ms linear;transform:", ";cursor:pointer;"], function (_ref2) {
  var isHovered = _ref2.isHovered;
  return isHovered ? '21px' : '18px';
}, function (_ref3) {
  var isHovered = _ref3.isHovered;
  return isHovered ? '21px' : '18px';
}, function (_ref4) {
  var collapsed = _ref4.collapsed;
  return collapsed ? '' : 'rotate(180deg)';
});

var MultiDataGridRow = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiDataGridRow, _React$Component);

  var _super = _createSuper(MultiDataGridRow);

  function MultiDataGridRow() {
    var _this;

    _classCallCheck(this, MultiDataGridRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      collapsed: true,
      highlighted: false,
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "manageCollapse", function () {
      _this.setState({
        collapsed: !_this.state.collapsed
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props$row = _this.props.row,
          row = _this$props$row === void 0 ? {} : _this$props$row;
      var collapsed = _this.state.collapsed;
      return /*#__PURE__*/React.createElement(RowContainer, {
        key: row.id
      }, /*#__PURE__*/React.createElement(_Header.Header, _extends({}, _this.props.header, {
        highlighted: _this.state.highlighted
      }), row.detail.length > 0 ? /*#__PURE__*/React.createElement(Collapser, {
        isHovered: _this.state.isHovered,
        collapsed: _this.state.collapsed,
        onClick: _this.manageCollapse,
        onMouseEnter: function onMouseEnter() {
          return _this.setState({
            isHovered: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this.setState({
            isHovered: false
          });
        }
      }) : null), _this.props.scrollable ? /*#__PURE__*/React.createElement(RowScrollableContainer, {
        className: "scroll-test-traffic-row"
      }, /*#__PURE__*/React.createElement(RowScrollableContent, null, /*#__PURE__*/React.createElement(MasterLine, _extends({
        key: row.id
      }, row, {
        master: true,
        onHover: function onHover(e) {
          return _this.setState({
            highlighted: e
          });
        }
      })), /*#__PURE__*/React.createElement(DetailedLines, {
        collapsed: collapsed
      }, row.detail.map(function (detail) {
        return /*#__PURE__*/React.createElement(_Line["default"], _extends({
          key: detail.id
        }, detail));
      })))) : /*#__PURE__*/React.createElement(RowContent, null, /*#__PURE__*/React.createElement(MasterLine, _extends({
        key: row.id
      }, row, {
        master: true
      })), /*#__PURE__*/React.createElement(DetailedLines, {
        collapsed: collapsed
      }, row.detail.map(function (detail) {
        return /*#__PURE__*/React.createElement(_Line["default"], _extends({
          key: detail.id
        }, detail));
      }))));
    });

    return _this;
  }

  return MultiDataGridRow;
}(React.Component);

_defineProperty(MultiDataGridRow, "defaultProps", {
  row: {
    id: null,
    timeLine: [],
    detail: [],
    tooltipClassName: '',
    layerItems: []
  },
  header: {
    width: '25%',
    caption: '',
    actions: [],
    tooltipClassName: ''
  }
});

var _default = MultiDataGridRow;
exports["default"] = _default;